import React, { useContext, useEffect, useState } from 'react';
import { DataContext } from '../../context/DataContext';
import TradingMetricsFull from './components/TradingMetricsFull';
import { OverallMetricsWithTitle } from '../../interfaces/Metrics';
import TradingMetricsCalculator from '../../helpers/TradingMetricsCalculator';
import { TradingData } from '../../helpers/CSVParser';
import { useTranslation } from '../../context/TranslationContext';
import { SettingsContext } from '../../context/SettingsContext';

const TradingMetricsPage = () => {
    const { dataset } = useContext(DataContext);
    const [metricsWithTitle, setMetricsWithTitle] = useState<OverallMetricsWithTitle[]>([]);
    const { t } = useTranslation();
    const { showAdvancedMetrics } = useContext(SettingsContext);

    useEffect(() => {
        const allMetrics: OverallMetricsWithTitle[] = [];
        let initialCapital = 0;
        let allTrades: TradingData[] = [];
        dataset.files.filter(file => file.include === true).forEach(file => {
            initialCapital += file.initialCapital;
            // filter parsedData by customStartDate and customEndDate if useAllTrades is false
            let filteredData = file.parsedData.filter(trade => trade.type.toLowerCase().includes('exit'));
            if (dataset.useDeepBacktest && dataset.customStartDate) {
                filteredData = filteredData.filter(trade => {
                    const tradeDate = new Date(trade.datetime);
                    return dataset.customStartDate ? tradeDate >= new Date(dataset.customStartDate) : false;
                });
            }
            if (dataset.useDeepBacktest && dataset.customEndDate) {
                filteredData = filteredData.filter(trade => {
                    const tradeDate = new Date(trade.datetime);
                    return dataset.customEndDate ? tradeDate <= new Date(dataset.customEndDate) : false;
                });
            }
            allTrades = [...allTrades, ...filteredData];
        });

        allTrades = TradingMetricsCalculator.recalculateTradeList(allTrades, initialCapital);
        const accumulatedMetrics = new TradingMetricsCalculator(allTrades, true, initialCapital).calculateOverallMetrics();
        allMetrics.push({ title: t('All'), metrics: accumulatedMetrics, tradingData: allTrades});   

        dataset.files.filter(file => file.include === true).forEach(file => {
            // filter parsedData by customStartDate and customEndDate if useAllTrades is false
            let filteredData = file.parsedData.filter(trade => trade.type.toLowerCase().includes('exit'));;
            if (dataset.useDeepBacktest && dataset.customStartDate) {
                filteredData = filteredData.filter(trade => {
                    const tradeDate = new Date(trade.datetime);
                    return dataset.customStartDate ? tradeDate >= new Date(dataset.customStartDate) : false;
                });
            }
            if (dataset.useDeepBacktest && dataset.customEndDate) {
                filteredData = filteredData.filter(trade => {
                    const tradeDate = new Date(trade.datetime);
                    return dataset.customEndDate ? tradeDate <= new Date(dataset.customEndDate) : false;
                });
            }
            const metrics = new TradingMetricsCalculator(filteredData, true, file.initialCapital).calculateOverallMetrics();
            if (metrics) {
                allMetrics.push({ title: file.customId, metrics, tradingData: filteredData });
            }
        });   
        setMetricsWithTitle(allMetrics);
    }, [dataset, t]);

    return (
        <div>
            <h1>{t('Trading Metrics')}</h1>
            {!metricsWithTitle && <p>{t('Loading...')}</p>}
            {metricsWithTitle && !showAdvancedMetrics && <TradingMetricsFull metricsArray={metricsWithTitle} fullMetrics={false} />}
            {metricsWithTitle && showAdvancedMetrics && <TradingMetricsFull metricsArray={metricsWithTitle} fullMetrics={true} />}
        </div>
    );
};

export default TradingMetricsPage;
